import { rgba } from 'polished';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Avatar, Paragraph, Skeleton, tokens } from '@treams/treams-ui';

const Name = styled(Box)`
	font-weight: bold;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const Footnote = styled(Paragraph)`
	font-size: 12px;
	line-height: 15px;
`;

const Container = styled(Flex)<{ $enabled?: boolean; $selected?: boolean; $color: string }>`
	border-radius: 5px;
	background: ${(props) => props.theme.colors.white};
	box-shadow:
		0px 0px 0px 1px ${rgba(tokens.text.secondary, 0.25)},
		0px 2px 4px ${rgba(tokens.text.secondary, 0.25)};
	width: 180px;
	height: 48px;
	padding: 0px 10px 0px 4px;
	font-size: 14px;
	line-height: 14px;
	align-items: center;
	border-left: 4px solid ${(props) => props.theme.colors[props.$color]};

	${(props) =>
		props.$enabled !== false &&
		`
	cursor: pointer;

	&:hover {
		box-shadow: 0px 0px 0px 1px ${rgba(tokens.text.secondary, 0.5)},
			0px 2px 4px ${rgba(tokens.text.secondary, 0.25)};
	}`}

	${(props) =>
		props.$selected &&
		`
		${Footnote} {
			color: ${rgba(props.theme.colors.white, 0.5)};
		}
		
		&, &:hover {
			background: ${props.theme.colors.primary};
			color: ${props.theme.colors.white};
			border-left-color: ${rgba(props.theme.colors.white, 0.5)};
			box-shadow: 0px 0px 0px 2px ${rgba(props.theme.colors.primary, 0.25)};
		}
	`}
`;

export default function GroupMember(props: { user: graphql.User; role: graphql.Role }) {
	const { t } = useTranslation();

	return (
		<Link to={`/settings/employees/${props.user.id}`}>
			<Container $color="employee">
				<Avatar user={props.user} size={32} mr={2} />
				<Box>
					<Name>
						{props.user.firstName} {props.user.lastName}
					</Name>
					{props.role && <Footnote>{t(`roles.${props.role.id}`)}</Footnote>}
				</Box>
			</Container>
		</Link>
	);
}

function GroupMemberSkeleton() {
	return <Skeleton.Box width={180} height={48} />;
}

GroupMember.Skeleton = GroupMemberSkeleton;
